import React, { FC, useEffect, useMemo } from "react";
import { FieldArray } from "react-final-form-arrays";
import { IWizardStepContent } from "../../../../wizard/types";
import {
  AdditionalRequiredDocs,
  ApplicationFiles,
  CourseDuration,
  HousingType,
  RequiredDocsMultiSelect,
  RestrictedCountries,
} from "../../components";
import { useForm, useFormState } from "react-final-form";
import { CourseType } from "../../../types";

const Content: FC<IWizardStepContent> = ({ stepName, values }) => {
  const { submitFailed, dirtySinceLastSubmit, invalid, submitErrors } =
    useFormState();
  const { change } = useForm();

  const hasError = useMemo(
    () => invalid && submitFailed && !dirtySinceLastSubmit,
    [invalid, dirtySinceLastSubmit, submitFailed],
  );
  const errors = useMemo(
    () => (hasError && submitErrors?.[stepName] ? submitErrors[stepName] : {}),
    [hasError, submitErrors],
  );

  const courseType = +values?.step1?.courseType;

  useEffect(() => {
    if (courseType === CourseType.ONLINE) {
      change(`${stepName}.housingTypes`, []);
    }
  }, [courseType]);

  return (
    <>
      <FieldArray
        name={`${stepName}.requiredDocs`}
        errors={errors}
        infoText={"Choose at least 1 required document"}
        component={RequiredDocsMultiSelect}
      />
      <AdditionalRequiredDocs fieldsGroupName={stepName} />
      <ApplicationFiles fieldsGroupName={stepName} />
      <CourseDuration fieldsGroupName={stepName} />
      <FieldArray
        name={`${stepName}.housingTypes`}
        errors={errors}
        disabled={courseType === CourseType.ONLINE}
        component={HousingType}
      />
      <RestrictedCountries fieldsGroupName={stepName} />
    </>
  );
};

export default Content;
